import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type LineDivType = {
    pos: string;
};

type LockIconType = {
    linked: boolean;
};

type InputDivType = {
    border: string;
};

export const BlockPaddingDiv = styled.div`
    display: flex;
`;

export const LinkedButtonDiv = styled.div`
    width: 42px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 18px;
`;

export const LineDiv = styled.div<LineDivType>`
    border-top: ${({ pos, theme }) => (pos === 'Top' ? `1px solid ${theme.colors.neutral100}` : 'none')};
    border-bottom: ${({ pos, theme }) => (pos === 'Bottom' ? `1px solid ${theme.colors.neutral100}` : 'none')};
    border-right: ${({ theme }) => `1px solid ${theme.colors.neutral100}`};
    height: 16px;
    width: 30px;
`;

export const LockIcon = styled(FontAwesomeIcon)<LockIconType>`
    font-size: 14px;
    padding: 3px;
    margin-left: 20px;
    color: ${({ linked, theme }) => (linked ? theme.colors.primary300 : theme.colors.neutral700)};
    cursor: pointer;
`;

export const InputDiv = styled.div<InputDivType>`
    width: 135px;
    height: 18px;
    padding: 5px;
    margin: 0px 0px 4px;
    border: ${({ border }) => border};
    display: flex;
    justify-content: space-between;
    min-width: 0;
    position: relative;
`;

export const InputTextDiv = styled.div`
    display: flex;
`;

export const IconDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const PXDiv = styled.div`
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.neutral700};
`;

export const ArrowDiv = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 2px;
`;

export const PaddingTopError = styled.div`
    color: ${({ theme }) => theme.colors.danger700};
    font-size: 10px;
    font-weight: 600;
    position: absolute;
    top: 40px;
`;

export const PaddingBottomError = styled.div`
    color: ${({ theme }) => theme.colors.danger700};
    font-size: 10px;
    font-weight: 600;
    position: absolute;
    top: 86px;
`;

export const Label = styled.span`
    color: ${({ theme }) => theme.colors.neutral700};
    font-weight: 400;
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 1px;
`;
